import styled from 'styled-components';

const ContentContainer = styled.div`
  overflow: hidden;
  width: 100%;
  padding: 0 15px;
`;

export default ContentContainer;
